import React from 'react'

const AboutUs = () => {
    return (
        <>
            <div className='container'>
                <h1
                    class="max-w-2xl p-10 mx-auto text-center font-manrope font-bold text-4xl text-gray-900 mb-5 md:text-5xl leading-[50px]">
                    About Us - Sevelian India
                </h1>
                <p class="max-w-4xl p-10 mx-auto text-center text-base font-normal leading-7 text-gray-500 mb-9">
                    We aim at providing the Indian Millennials with the coolest clothing at affordable prices without compromising on quality!
                    We make professional style pieces designed to give you the fashionable edge at affordable prices! Wear it in your college, for brunch, lunch, dinner, at the cafe, or at the mall - wherever you like! 

                    Sevelian India is a lifestyle products brand under parent company CastalRock Company.
                </p>
            </div>
        </>
    )
}

export default AboutUs